module.exports = __webpack_public_path__ + "static/media/font-family.2916c803.png";